const formatNumber = (number) => {
  let str = Number(number).toLocaleString();
  return str;
};

export default formatNumber;